// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__Zmd2R","fileBtn":"File_fileBtn__17ioo","closeBtn":"File_closeBtn__33aGk","fileSelected":"File_fileSelected__3AtyD","disabled":"File_disabled__D05No"};